import { Link } from "react-router-dom";
import { editorialPersonName } from "../../../../shared/editorialSeo";

type Person = { slug: string; name: string; credentials?: string | null };

export default function ArticleByline({ author, reviewer, reviewedAt }: {
  author?: Person | null; reviewer?: Person | null; reviewedAt?: string | null;
}) {
  if (!author) return null;
  const samePerson = reviewer?.slug === author.slug;
  const personLink = (person: Person) => <Link className="underline underline-offset-2" to={`/authors/${person.slug}`}>{editorialPersonName(person)}</Link>;
  return <div className="mt-2 text-sm text-blue-200">
    <p>{samePerson ? "Written and clinically reviewed by " : "By "}{personLink(author)}</p>
    {reviewer && !samePerson && <p className="mt-2">Reviewed by {personLink(reviewer)}
      {reviewedAt && <> on <time dateTime={reviewedAt}>{new Date(reviewedAt).toLocaleDateString()}</time></>}
    </p>}
    {samePerson && reviewedAt && <p className="mt-1">Reviewed on <time dateTime={reviewedAt}>{new Date(reviewedAt).toLocaleDateString()}</time></p>}
  </div>;
}
